import { transactionDateStore } from "hooks";

export const salesReportFilterState = (venue) => {
  const { venueId, startDate, endDate } = transactionDateStore(venue);
  return {
    venueId,
    page: 1,
    pageSize: 10,
    searchKey: "",
    dateRange: [startDate, endDate],
  };
};
